export const formUri = 'https://hop.studiokoko.be/koko-mail/renovant';